module.exports = __webpack_public_path__ + "img/图片9.d7b4ed89.png";